import { TagColor as Color, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface AssignedTagProps {
  employeeStatus: boolean
}

const AssignedTag = ({ employeeStatus }: AssignedTagProps) => {
  const type = employeeStatus ? Color.viridian : Color.grey

  return (
    <Tag leftItem="circle" inline capitalize showCircle type={type}>
      <Text size="200" capitalize weight="semibold">
        {employeeStatus
          ? i18n.t('project_management.table.project_employees.assignation_tags.assigned')
          : i18n.t('project_management.table.project_employees.assignation_tags.not_assigned')}
      </Text>
    </Tag>
  )
}

export default AssignedTag
